import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportListaFornecedorUseCase } from "../../../presentation/useCases/read/get_report_lista_fornecedor_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

/**
 * GetReportListaFornecedorUseCase
 */

export class GetReportListaFornecedorUseCase implements IGetReportListaFornecedorUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportListaFornecedor(
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.repository.getReportListaFornecedor(
      requiredMimeType,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `lista_fornecedores_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
